import LightningFS from "@isomorphic-git/lightning-fs"
import {IPFS} from "ipfs-core"
import all from "it-all"
import JSZip from "jszip"
import KeyValueStore from "orbit-db-kvstore"
import {useCallback, useContext, useEffect, useState} from "react"
import {BackendContext} from "../context/BackendContext"
import {concat} from "uint8arrays"

export const useCloneRepo = (repoReplCnt: number, repoDB?: KeyValueStore<any>) => {
  const {ipfs, fs} = useContext(BackendContext)
  const [cloneCnt, setCloneCnt] = useState(0)

  const cloneRepo = useCallback(async (
    ipfs: IPFS,
    fs: LightningFS,
    repoDB: KeyValueStore<any>
  ) => {
    console.log("DEBUG: cloneRepo begin")

    const repoCID = repoDB.get("cid")
    console.log(repoCID)
    if (!repoCID) {
      return
    }

    const repoAddress = repoDB.address.toString()
    const gitDir = repoAddress.replace(/^\/orbitdb/, "")

    await window.indexedDB.databases()
    await fs.promises.init("fs", {wipe: true} as any)

    try {
      const root = gitDir.split("/")[1]
      await fs.promises.mkdir(`/${root}`)
      await fs.promises.mkdir(gitDir)
    } catch (e) {
      console.log("fs.promises.mkdir initial failed")
    }

    console.log("DEBUG: cloneRepo - cat contents begins", repoCID)
    const contents = await all(ipfs.cat(repoCID))
    console.log("DEBUG: cloneRepo - cat contents ends")

    const zip = new JSZip()
    const gitRepo = await zip.loadAsync(Buffer.from(concat(contents)))

    for (const [path, file] of Object.entries(gitRepo.files).sort()) {
      const contents = await file.async("uint8array")

      if (file.dir) {
        try {
          await fs.promises.mkdir(`${gitDir}/${path}`)
        } catch (e) {
          console.log("fs.promises.mkdir error", e)
        }
        continue
      }

      try {
        await fs.promises.writeFile(
          `${gitDir}/${path}`,
          contents,
          "utf8"
        )
      } catch (e) {
        console.log("fs.promises.writeFile error")
      }
    }

    setCloneCnt(prevState => prevState + 1)

    console.log("DEBUG: cloneRepo end")
  }, [])

  useEffect(() => {
    if (!repoDB || !ipfs || !fs) {
      return
    }
    cloneRepo(ipfs, fs, repoDB).then()
  }, [ipfs, fs, repoDB, repoReplCnt, cloneRepo])

  return {
    cloneCnt
  }
}
